import { post } from '@/utils/request'

// 登录接口
export function login(data) {
  return post('/users/admin/login', data)
} 